(function(ns) {
	"use strict";

	var util = ns.util;

	util.component("root-view", {
		props: ["valid_post", "action"],
		data: function() {
			ns.restoreState(); // 保存されたデータを取得
			return {
				step: "company",
				stepDoneNum: 1,
				state: ns.store.state,
				entry: ns.store.entry,
				entry_error: ns.store.entry_error
			};
		},
		methods: {
			switchToView: function(view) {
				this.step = view;
				this.state.saveError = false; // View を切り替えたときはエラーをリセット
				window.scrollTo(0, 40);

				switch (view) {
					case "shop":
						this.stepDoneNum = 2;
						break;
					default:
						this.stepDoneNum = 1;
						break;
				}
			},
			switchToNextView: function(fromView) {
				this.state.saveError = false; // View を切り替えたときはエラーをリセット
				window.scrollTo(0, 40);

				if (this.state.reedit) {
					this.step = "confirm";
					return;
				}
				switch (fromView) {
					case "company":
						this.step = "shop";
						this.stepDoneNum = 2;
						break;
					default:
						this.step = "confirm";
						this.stepDoneNum = 3;
						break;
				}
			},
			submit: function() {
				var me = this;

				me.state.loading = true;
				me.state.saveError = false;

				fetch(me.action + "?" + Date.now(), {
					method: "POST",
					headers: {
						"Content-Type": "application/json"
					},
					body: JSON.stringify({
						valid_post: me.valid_post,
						entry: me.entry
					}),
					credentials: "same-origin"

				}).then(function(response) {
					return response.json();

				}).then(function(result) {
					if (result.errors && result.errors.login_email) {
						me.step = "company";
						me.state.loading = false;
						Vue.set(me.entry_error, "login_email", result.errors.login_email);
						// 描画更新後に実行
						setTimeout(function() {
							var invalidInput = document.querySelector(".is-invalid");
							if (!invalidInput) return;
							BS.Scroll.toElement(invalidInput.parentNode, 60);
						});
						return;
					}
					if (!result.success) {
						var error = new Error("Failed to create entry.");
						error.result = result;
						throw error;
					}
					me.state.loading = false;
					me.state.completed = true;
					ns.clearState();
					window.scrollTo(0, 40);

				}).catch(function(e) {
					console.log("データを保存できませんでした", e);
					me.state.loading = false;
					me.state.saveError = true;
				});
			},
			reset: function() {
				this.step = "company";
				this.stepDoneNum = 1;
				this.state.reedit = false;
				this.state.loading = false;
				this.state.saveError = false;
				this.state.completed = false;
				ns.store.resetEntry();
				ns.clearState();
			},
		},
		watch: {
			entry: {
				deep: true,
				handler: function() {
					ns.saveState(); // 変更があるたびに入力を保存する
				}
			}
		}
	});

})(CE);
